import React from "react";

export default function Good() {
  return (
    <g mask="url(#mask0)">
      <path
        d="M131.994 106.103C139.159 93.692 142.386 79.3972 141.247 65.1116L127.213 66.2309C128.126 77.6733 125.541 89.123 119.802 99.0639L131.994 106.103Z"
        fill="#7D237D"
      />
      <path
        d="M141.253 65.1855C140.128 50.8987 134.691 37.2904 125.66 26.1626L114.729 35.0336C121.962 43.9467 126.317 54.8467 127.218 66.29L141.253 65.1855Z"
        fill="#A83559"
      />
      <path
        d="M125.707 26.2201C116.688 15.0829 104.499 6.94774 90.7542 2.89191L86.77 16.3944C97.7794 19.643 107.542 26.1591 114.766 35.0797L125.707 26.2201Z"
        fill="#FF5354"
      />
      <path
        d="M48.8769 3.46264C35.2473 7.89115 23.2844 16.3551 14.5722 27.7337L25.75 36.2922C32.7283 27.1782 42.3103 20.3988 53.2272 16.8516L48.8769 3.46264Z"
        fill="#4FCBAD"
      />
      <path
        d="M14.9951 27.1863C6.1721 38.4792 0.98736 52.1858 0.127453 66.4909C-0.732454 80.7961 2.77304 95.025 10.1797 107.294L22.2318 100.018C16.2992 90.1908 13.4913 78.7937 14.1801 67.3357C14.8689 55.8776 19.0217 44.899 26.0888 35.8536L14.9951 27.1863Z"
        fill="#4BF0E6"
      />
      <path
        d="M90.8252 2.9129C77.0844 -1.15731 62.4314 -0.957826 48.8065 3.48495L53.1922 16.935C64.0922 13.3808 75.8146 13.2212 86.8072 16.4774L90.8252 2.9129Z"
        fill="#F0E65F"
      />
    </g>
  );
}
